module.exports = __webpack_public_path__ + "img/Logo_IC_Dezembro_vermelho.86fbf7b3.png";